var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-presupuestos"}},[(!_vm.$vuetify.breakpoint.mobile)?[_c('desktop',{attrs:{"ejercicio":_vm.ejercicio}})]:[_c('mobile',{attrs:{"ejercicio":_vm.ejercicio}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }